import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { $ } from '../../lib/util';
import type { Case } from '../../domain/initial-cases';
import { Dialog } from '../Dialog';
import { useUIState } from '../../state/contexts/UIStateContext';
import { useLifecycleActions } from '../../state/actions/lifecycle';

export function SubmitChangeModal({ c }: { c: Case }) {
  const { setModal } = useUIState();
  const { submitChange } = useLifecycleActions();
  return (
    <Dialog title="Submit Registrant Change" onClose={() => setModal(null)}>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="change-type" style={{ fontSize: 11, color: C.textMuted }}>Change Type</label>
          <select id="change-type" style={{ ...styles.select, width: '100%' }}>
            <option value="Caller Info Update">Caller Information Update</option>
            <option value="TN Change">Telephone Number Change</option>
            <option value="Display Name Change">Display Name Change</option>
            <option value="Call Reason Change">Call Reason Change</option>
            <option value="Call Logo Change">Call Logo Change</option>
            <option value="Status Change">Account Status Change</option>
          </select>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="change-details" style={{ fontSize: 11, color: C.textMuted }}>Details</label>
          <textarea id="change-details" style={styles.textarea} placeholder="Describe the change..." />
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => {
            const type = $('change-type').value;
            const details = $('change-details').value;
            if (details) { submitChange(c.id, type, details); setModal(null); }
          }}>Submit for Review</button>
          <button style={{ ...styles.btn, ...styles.btnOutline }} onClick={() => setModal(null)}>Cancel</button>
        </div>
    </Dialog>
  );
}
